module.exports = __webpack_public_path__ + "img/fi-rr-rocket.bf599246.svg";